// Module
var code = "<div class=\"ToolBarPreview\"> <label> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;